module.exports = __webpack_public_path__ + "img/cooperativeMedia7.10c48c1e.jpg";